<script setup>
import {ref} from "vue";
import {mdiClose} from "@mdi/js";

const props = defineProps({
    image: {
        type: Object,
        required: true,
    },
    small: {
        type: Boolean,
        default: false,
    }
});

const showDetail = ref(false);

function thumbnailSize(dimension) {
    if (props.small) {
        return dimension / 2;
    }
    return dimension;
}
</script>

<template>
    <v-card class="d-flex align-center" density="compact" border hover @click="showDetail = true">
        <v-card-text class="pa-1 d-flex flex-column align-center">
            <v-img :src="image.thumbnailUrl"
                   :width="thumbnailSize(image.thumbnailWidth)"
                   :height="thumbnailSize(image.thumbnailHeight)">
                <template v-slot:placeholder>
                    <div class="d-flex align-center justify-center fill-height">
                        <v-progress-circular
                            color="grey-lighten-4"
                            indeterminate
                        ></v-progress-circular>
                    </div>
                </template>
            </v-img>

            <p class="text-center mt-1">
                {{ formatShortDateTime(image.timestamp) }}
            </p>
        </v-card-text>
    </v-card>

    <v-dialog v-model="showDetail" fullscreen>
        <v-card>
            <v-card-title class="text-right">
                <v-btn rounded="xl" :icon="mdiClose" @click="showDetail = false" />
            </v-card-title>
            <v-card-text class="position-relative">
                <img class="full-image" :src="image.imageUrl" alt=""/>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<style scoped>
.full-image {
    width: 100%;
    height: 100%;
    object-fit: scale-down;
    max-height: calc(100dvh - 128px);
}
</style>